<template>
<div class="main">
   
<header class="centerH2">
    <a @click="()=>$router.push({name:'Center'})"  class="btn-back">
        <img src="@/assets/img/btn-back-black-record.png" alt="">
    </a>
    违规记录
</header>
<div class="main againstM">
    <div class="againstBox">
        <div class="hd">
            您已累计违规<span class="red">{{against}}</span>次
        </div>
        <div class="bd">
            <ul>
                <li v-for="item in items" :class="{'add':item.status==0,'reduce':item.status!=0,'againstItem':true}">
                    <a class="recordItem">
                            <div v-if="item.status==0" class="ldiv">
                                <img src="assets/img/ic_common_warning_red.png" alt="">
                                {{item.type==0?'超时':'超借'}}未还+1
                            </div>
                             <div v-if="item.status!=0" class="ldiv">
                                <img src="assets/img/ic_common_warning_white.png" alt="">
                            归还{{item.type==0?'超时':'超借'}}书籍-1
                            </div>
                            <div class="rdiv">
                                <p class="up">
                                   {{moment(item.createTime).format('YYYY.MM.DD')}}
                                </p>
                                <p class="down">
                                    点击收起
                                </p>
                            </div>
                        </a>
                    <div class="recordInfo">
                        <p>
                            书名：{{item.bookName}}
                        </p>
                        <p>
                            作者：{{item.author}}
                        </p>
                        <p>
                            借书时间： {{moment(item.borrowTime).format('YYYY.MM.DD')}}
                        </p>
                        <p>
                            应还时间： {{moment(item.planTime).format('YYYY.MM.DD')}}
                        </p>
                        <p>
                            违规原因：逾期<span class="red">14</span>天未还
                        </p>
                    </div>
                </li>
                <!-- <li class="reduce againstItem">
                    <a href="##" class="recordItem">
                        <div class="ldiv">
                            <img src="assets/img/ic_common_warning_white.png" alt="">
                            归还超时书籍-1
                        </div>
                        <div class="rdiv">
                            <p class="up">
                                2020.02.02
                            </p>
                            <p class="down">
                                点击收起
                            </p>
                        </div>
                    </a>
                    <div class="recordInfo">
                        <p>
                            书名：庆余年
                        </p>
                        <p>
                            作者：不知道
                        </p>
                        <p>
                            借书时间：2020.02.02
                        </p>
                        <p>
                            应还时间：2020.02.05
                        </p>
                        <p>
                            违规原因：逾期<span class="red">14</span>天未还
                        </p>
                    </div>
                </li> -->
            </ul>
        </div>
    </div>
    <div class="tip">
        累计超过{{rule.forbiddenNumber}}次将被禁用线上功能
    </div>
</div>
<loading :active.sync="isLoading" 
        color="#f4a84e"
        :is-full-page="fullPage"></loading>
</div>
</template>
<script>
import moment from 'moment'
import {getViolation} from "@/api/user"
import {getRule} from '@/api/book'
import { USER } from "@/store/mutation-types";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {
            Loading
        },
    data(){
        return {
            items:[],
            rule:{},
            against:0,
            isLoading: false,
            fullPage: true,
            customerId:null
        }
    },
    methods:{
        moment,
        getViolationData(){
            this.isLoading = true
            getViolation({'customerId':this.customerId}).then(res =>{
                this.isLoading = false
                this.items = res.data.content
            }) .catch(error => {
                this.isLoading = false
            });
        },
        getRuleData(){
            getRule(this.customerId).then(res =>{
                this.rule = res.data
            })
        }
    },
    mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
     this.isLoading = true
      this.customerId =  this.$route.query.customerId || this.$ls.get("CUSTOMER") 
    this.getViolationData()
    this.getRuleData()
    var user = this.$ls.get(USER)
    this.against = user.against;
  }
};
</script>
<style scoped>
@import "~@/assets/css/center.css";
</style>
